// Centralized UI messages for the application

export const LOADING_MESSAGE = 'Fetching data. Please wait...';
export const EMPTY_DATA_MESSAGE = 'No data found in the selected time window.';

// KPI Labels
export const KPI_ERROR_RATE = 'Error Rate';
export const KPI_LATENCY_P50 = 'P50 Latency';
export const KPI_LATENCY_P95 = 'P95 Latency';
export const KPI_PROMPT_INJECTIONS = 'Prompt Injections';
export const KPI_DATA_EXFILTRATIONS = 'Data Exfiltrations';
export const KPI_TOKENS = 'Tokens';
export const KPI_TRACES = 'Traces';
export const KPI_SPANS = 'Spans';
export const KPI_SESSIONS = 'Sessions';
export const KPI_AGENTS = 'Agents';
export const KPI_TOOLS = 'Tools';
export const KPI_PROFIT = 'Net Profit';
export const KPI_TOTAL_TRADES = 'Total Trades';
export const KPI_WIN_RATE = 'Win Rate';

// Graph Tab Labels
export const GRAPH_SYSTEM_PROMPT_TITLE = 'System Prompt';
export const GRAPH_SYSTEM_PROMPT_UNAVAILABLE = '(System prompt not available)';
export const GRAPH_MINIMAP_SHOW = 'Show';
export const GRAPH_MINIMAP_HIDE = 'Hide';
export const GRAPH_MINIMAP_LABEL = 'MiniMap';
export const GRAPH_SELECT_NODE_MESSAGE = 'Select a node to view details';

// Traces Table Column Tooltips
export const TRACES_QUALITY_TOOLTIP = 'Number of spans with quality scores, distributed across P20 buckets (0.0-0.2 = red/poor, 0.8-1.0 = green/excellent)';

// Security Tab Labels
export const SECURITY_NO_ISSUES = 'No signals detected';
export const SECURITY_INPUT_TAB = 'Input Security';
export const SECURITY_INPUT_TOOLTIP = 'Detections on system and user messages (before span execution)';
export const SECURITY_OUTPUT_TAB = 'Output Security';
export const SECURITY_OUTPUT_TOOLTIP = 'Detections on assistant messages (after span execution)';
export const SECURITY_OTHER_TAB = 'Other Security';
export const SECURITY_OTHER_TOOLTIP = 'Detections with unclassified prompt type';
export const SECURITY_DETECTION_SINGULAR = 'detection';
export const SECURITY_DETECTION_PLURAL = 'detections';
